//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './MaterialClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchMaterialQueryParameters = {
  search?: string | null | undefined ;
}

export type GetRecipesUsingMaterialMaterialQueryParameters = {
  materialId: number ;
}

export type CopyMaterialQueryParameters = {
  materialId: number ;
}

export type DeleteMaterialQueryParameters = {
  id: number ;
}

export type PatchMaterialQueryParameters = {
  id: number ;
}

export type AddMaterialToInventoryMaterialQueryParameters = {
  materialId: number ;
}

export type RemoveMaterialFromInventoryMaterialQueryParameters = {
  materialId: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/material";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'MaterialClient',
      'create',
    ]);
}

/**
 * Creates a new material.
 * @param dto Dto with data for creation.
 * @return Dto with material's data.
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, Types.CreateMaterialDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MaterialDto, unknown, Types.CreateMaterialDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateMaterialDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function searchUrl(search?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/material?";
if (search !== undefined && search !== null)
    url_ += "search=" + encodeURIComponent("" + search) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.MaterialDto[], unknown, Types.MaterialDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MaterialDto[], unknown, Types.MaterialDto[]>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(search?: string | null | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { search,  } = params[0] as SearchMaterialQueryParameters;

    return trimArrayEnd([
        'MaterialClient',
        'search',
        search as any,
      ]);
  } else {
    return trimArrayEnd([
        'MaterialClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as string | null | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.MaterialDto[], TError = unknown>(dto: SearchMaterialQueryParameters, options?: Omit<UseQueryOptions<Types.MaterialDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns a list of the materials satisfied by search string.
If search string is null or empty, returns all materials.
 * @param search (optional) Search string.
 */
export function useSearchQuery<TSelectData = Types.MaterialDto[], TError = unknown>(search?: string | null | undefined, options?: Omit<UseQueryOptions<Types.MaterialDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.MaterialDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MaterialDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let search: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ search,  } = params[0] as SearchMaterialQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [search, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MaterialDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(search),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.MaterialDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns a list of the materials satisfied by search string.
If search string is null or empty, returns all materials.
 * @param search (optional) Search string.
 */
export function setSearchData(queryClient: QueryClient, updater: (data: Types.MaterialDto[] | undefined) => Types.MaterialDto[], search?: string | null | undefined) {
  queryClient.setQueryData(searchQueryKey(search),
    updater
  );
}

/**
 * Returns a list of the materials satisfied by search string.
If search string is null or empty, returns all materials.
 * @param search (optional) Search string.
 */
export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MaterialDto[] | undefined) => Types.MaterialDto[]) {
  queryClient.setQueryData(queryKey, updater);
}

export function getRecipesUsingMaterialUrl(materialId: number): string {
  let url_ = getBaseUrl() + "/api/material/{materialId}/recipes";
if (materialId === undefined || materialId === null)
  throw new Error("The parameter 'materialId' must be defined.");
url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getRecipesUsingMaterialDefaultOptions: Omit<UseQueryOptions<Types.MaterialUsageDto, unknown, Types.MaterialUsageDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MaterialUsageDto, unknown, Types.MaterialUsageDto>, 'queryFn'>> = {
};
export function getGetRecipesUsingMaterialDefaultOptions() {
  return getRecipesUsingMaterialDefaultOptions;
};
export function setGetRecipesUsingMaterialDefaultOptions(options: typeof getRecipesUsingMaterialDefaultOptions) {
  getRecipesUsingMaterialDefaultOptions = options;
}

export function getRecipesUsingMaterialQueryKey(materialId: number): QueryKey;
export function getRecipesUsingMaterialQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { materialId,  } = params[0] as GetRecipesUsingMaterialMaterialQueryParameters;

    return trimArrayEnd([
        'MaterialClient',
        'getRecipesUsingMaterial',
        materialId as any,
      ]);
  } else {
    return trimArrayEnd([
        'MaterialClient',
        'getRecipesUsingMaterial',
        ...params
      ]);
  }
}
export function __getRecipesUsingMaterial(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getRecipesUsingMaterial(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetRecipesUsingMaterialQuery<TSelectData = Types.MaterialUsageDto, TError = unknown>(dto: GetRecipesUsingMaterialMaterialQueryParameters, options?: Omit<UseQueryOptions<Types.MaterialUsageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns the user's own recipes that use the given material (most-recently-changed first,
capped) together with the total count, for the material card's "used in recipes" section.
 * @param materialId Id of the material to look up.
 */
export function useGetRecipesUsingMaterialQuery<TSelectData = Types.MaterialUsageDto, TError = unknown>(materialId: number, options?: Omit<UseQueryOptions<Types.MaterialUsageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetRecipesUsingMaterialQuery<TSelectData = Types.MaterialUsageDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MaterialUsageDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let materialId: any = undefined;

  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ materialId,  } = params[0] as GetRecipesUsingMaterialMaterialQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [materialId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MaterialUsageDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getRecipesUsingMaterial(context, axiosConfig) : __getRecipesUsingMaterial,
    queryKey: getRecipesUsingMaterialQueryKey(materialId),
    ...getRecipesUsingMaterialDefaultOptions as unknown as Omit<UseQueryOptions<Types.MaterialUsageDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function copyUrl(materialId: number): string {
  let url_ = getBaseUrl() + "/api/material/{materialId}/copy";
if (materialId === undefined || materialId === null)
  throw new Error("The parameter 'materialId' must be defined.");
url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function copyMutationKey(materialId: number): MutationKey {
  return trimArrayEnd([
      'MaterialClient',
      'copy',
      materialId as any,
    ]);
}

/**
 * Copies a material into the user's own materials, so they can adjust a formula they do not own.
 * @param materialId Id of the material to copy.
 * @return Dto with the copy's data.
 */
export function useCopyMutation<TContext>(materialId: number, options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MaterialDto, unknown, void, TContext> {
  const key = copyMutationKey(materialId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.copy(materialId),
    mutationKey: key,
  });
}
  
type Copy__MutationParameters = CopyMaterialQueryParameters

/**
 * Copies a material into the user's own materials, so they can adjust a formula they do not own.
 * @param materialId Id of the material to copy.
 * @return Dto with the copy's data.
 */
export function useCopyMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, Copy__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CopyMaterialQueryParameters}): UseMutationResult<Types.MaterialDto, unknown, Copy__MutationParameters, TContext> {
  const key = copyMutationKey(options?.parameters?.materialId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Copy__MutationParameters) => Client.copy(data.materialId ?? options?.parameters?.materialId!),
  mutationKey: key,
});
}
  
export function deleteUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/material/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'MaterialClient',
      'delete',
      id as any,
    ]);
}

/**
 * Deletes an existing material.
 * @param id Id of a material to delete.
 */
export function useDeleteMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.delete_(id),
    mutationKey: key,
  });
}
  
type Delete__MutationParameters = DeleteMaterialQueryParameters

/**
 * Deletes an existing material.
 * @param id Id of a material to delete.
 */
export function useDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Delete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteMaterialQueryParameters}): UseMutationResult<void, unknown, Delete__MutationParameters, TContext> {
  const key = deleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Delete__MutationParameters) => Client.delete_(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/material/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'MaterialClient',
      'patch',
      id as any,
    ]);
}

/**
 * Patches existing material with new data.
 * @param id Id of the material to patch.
 * @param dto Dto with updated data of the material.
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, Types.PatchMaterialDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MaterialDto, unknown, Types.PatchMaterialDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchMaterialDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchMaterialQueryParameters & {
  dto: Types.PatchMaterialDto;
}

/**
 * Patches existing material with new data.
 * @param id Id of the material to patch.
 * @param dto Dto with updated data of the material.
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchMaterialQueryParameters}): UseMutationResult<Types.MaterialDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function addMaterialToInventoryUrl(materialId: number): string {
  let url_ = getBaseUrl() + "/api/material/inventory/{materialId}";
if (materialId === undefined || materialId === null)
  throw new Error("The parameter 'materialId' must be defined.");
url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addMaterialToInventoryMutationKey(materialId: number): MutationKey {
  return trimArrayEnd([
      'MaterialClient',
      'addMaterialToInventory',
      materialId as any,
    ]);
}

/**
 * Adds Material to user's inventory.
 * @param materialId Id of the Material
 */
export function useAddMaterialToInventoryMutation<TContext>(materialId: number, options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MaterialDto, unknown, void, TContext> {
  const key = addMaterialToInventoryMutationKey(materialId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.addMaterialToInventory(materialId),
    mutationKey: key,
  });
}
  
type AddMaterialToInventory__MutationParameters = AddMaterialToInventoryMaterialQueryParameters

/**
 * Adds Material to user's inventory.
 * @param materialId Id of the Material
 */
export function useAddMaterialToInventoryMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, AddMaterialToInventory__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: AddMaterialToInventoryMaterialQueryParameters}): UseMutationResult<Types.MaterialDto, unknown, AddMaterialToInventory__MutationParameters, TContext> {
  const key = addMaterialToInventoryMutationKey(options?.parameters?.materialId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: AddMaterialToInventory__MutationParameters) => Client.addMaterialToInventory(data.materialId ?? options?.parameters?.materialId!),
  mutationKey: key,
});
}
  
export function removeMaterialFromInventoryUrl(materialId: number): string {
  let url_ = getBaseUrl() + "/api/material/inventory/{materialId}";
if (materialId === undefined || materialId === null)
  throw new Error("The parameter 'materialId' must be defined.");
url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMaterialFromInventoryMutationKey(materialId: number): MutationKey {
  return trimArrayEnd([
      'MaterialClient',
      'removeMaterialFromInventory',
      materialId as any,
    ]);
}

/**
 * Removes Material from user's inventory.
 * @param materialId Id of the Material
 */
export function useRemoveMaterialFromInventoryMutation<TContext>(materialId: number, options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MaterialDto, unknown, void, TContext> {
  const key = removeMaterialFromInventoryMutationKey(materialId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeMaterialFromInventory(materialId),
    mutationKey: key,
  });
}
  
type RemoveMaterialFromInventory__MutationParameters = RemoveMaterialFromInventoryMaterialQueryParameters

/**
 * Removes Material from user's inventory.
 * @param materialId Id of the Material
 */
export function useRemoveMaterialFromInventoryMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.MaterialDto, unknown, RemoveMaterialFromInventory__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveMaterialFromInventoryMaterialQueryParameters}): UseMutationResult<Types.MaterialDto, unknown, RemoveMaterialFromInventory__MutationParameters, TContext> {
  const key = removeMaterialFromInventoryMutationKey(options?.parameters?.materialId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveMaterialFromInventory__MutationParameters) => Client.removeMaterialFromInventory(data.materialId ?? options?.parameters?.materialId!),
  mutationKey: key,
});
}